var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trunBack"},[_c('i',{staticClass:"el-icon-arrow-left",on:{"click":_vm.returnBack}}),_c('div',{staticClass:"trunBackContent"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }